export const POLL_INTERVAL_MS = 3_000;
export const POLL_TAKING_LONGER_MS = 30_000;
export const POLL_TIMEOUT_MS = 5 * 60_000;
export const MAX_TRANSIENT_POLLS = 4;
